import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import ArtistBooking from './pages/ArtistBooking';

function App() {
  return (
    <Router>
      <Routes>
        {/* Main landing page */}
        <Route path="/" element={<Home />} />
        
        {/* Dedicated artist landing pages (Google Ads targets) */}
        <Route path="/book/:artistId" element={<ArtistBooking />} />
      </Routes>
    </Router>
  );
}

export default App;
